declare global {
    interface Window {
        truste: any;
    }
}

const trustarcInit = () => {
    const trustarcScript = document.createElement('script');
    trustarcScript.id = "trustarcScript";
    trustarcScript.type = "text/javascript";
    trustarcScript.async = true;
    trustarcScript.src = "https://consent.trustarc.com/v2/notice/9ihlel";
    document.getElementById('consent-banner-container')?.appendChild(trustarcScript);
}

export const preferenceReload = () => {
    if (!window.truste) {
        trustarcInit();
    }
};